import React, { Component } from "react";
import { connect } from "react-redux";
import { doGetChannelGroups, doGetDisclaimer, doGetDisclaimers } from "../../../../actions/lists";
import { doUpsertDisclaimer } from "../../../../actions/inserts";
import { Disclaimer } from "../../../../utils/Models";
import { doGetClients, ClientActions, IMemberCount } from "../../../../../client/actions";
import ElementEditCard from "../../../molecules/ElementEditCard";
import { RouteComponentProps } from "react-router-dom";

interface IEditDisclaimerProps extends RouteComponentProps<{ did: string; }> {
    user: Mongo.clientAdmin;
}
interface IEditDisclaimerState extends Mongo.IDisclaimer {
    clients: Mongo.IClient[];
    channelGroupsList: string[];
    clientMemberCount?: IMemberCount | null;
    usedChannelGroups: string[];
    loading: boolean;
}

class EditDisclaimer extends Component<IEditDisclaimerProps, IEditDisclaimerState> {
    static allowSuper = true;
    static allowClientAdmin = true;
    static allowSuperClientAdmin = true;
    static allowAdmin = false;
    static allowApiAdmin = false;
    static allowCurator = false;
    static allowReports = false;

    constructor(props: IEditDisclaimerProps) {
        super(props);
        this._setState = this._setState.bind(this);
        let did = "";

        if (props.match.params.did) {
            did = props.match.params.did;
        }

        this.state = {
            did,
            clients: [],
            name: "",
            loading: true,
            cid: "",
            channelGroups: [],
            shortDisclaimer: "",
            longDisclaimer: "",
            date_created: new Date(),
            clientMemberCount: null,
            channelGroupsList: [],
            usedChannelGroups: []
        };
    }

    async componentDidMount() {
        const clients = await doGetClients();
        this.setState({ clients, loading: false });
        if (this.state.did) {
            const disclaimer = await doGetDisclaimer(this.state.did);
            if (disclaimer && disclaimer[this.state.did]) {
                this.setState({ insert: false, ...disclaimer[this.state.did] });
            }
            await this.setChannelGroups(disclaimer.cid);
        }
        if ((clients && clients.length === 1) || this.state.cid) {
            const cid = this.state.cid || clients[0]?.cid;
            const clientMemberCount = (await ClientActions.doGetMemberCount(cid, false)) as IMemberCount;
            await this._getUsedChannels(cid);
            await this.setChannelGroups(cid);
            this.setState({ clientMemberCount, cid });
        }
    }

    async setChannelGroups(cid: string){
        const { clients } = this.state;
        const client = clients.find(client => client.cid === cid);
        if (client && client.compliance && client.compliance.vendor === "ssg") {
            doGetChannelGroups(cid).then((data)=>{
                this._setState({ channelGroupsList: data });
            });
        }
    }

    _setState(item) {
        this.setState(item);
    }

    async _getUsedChannels(cid: string) {
        const disclaimers = await doGetDisclaimers({ cid });
        const usedChannelGroups = [] as string[];
        disclaimers.items.map(disclaimer => {
            disclaimer.channelGroups.map(channelGroup => {
                usedChannelGroups.push(channelGroup);
            });
        });
        this.setState({ usedChannelGroups });
    }

    _onSubmit(item: Mongo.IDisclaimer) {
        const disclaimer = Disclaimer({
            ...item,
            cid: this.state.cid || item.cid,
            date_created: new Date()
        });
        return doUpsertDisclaimer(disclaimer);
    }

    render() {
        const { user } = this.props;
        const { clients } = this.state;
        const ssgClients = clients.filter(client => client.compliance?.vendor === "ssg");
        return (
            <ElementEditCard<Mongo.IDisclaimer>
                getItem={async () => Disclaimer({ ...(await doGetDisclaimer(this.state.did)) })}
                canUpdate={() => Promise.resolve(true)}
                update={item => this._onSubmit(item)}
                breadcrumbs={[{ name: "Disclaimers", link: "/disclaimer" }]}
                elementName="Disclaimers"
                isInsert={item => !!(!item || !item.did)}
                loading={!!this.state.loading}
                rows={[
                    {
                        columns: [
                            { label: "Details", items: ["name", "cid", "channelGroups"], key: "DisclaimerEdit_R1C1" },
                            {
                                label: "Disclaimer Text",
                                items: ["shortDisclaimer", "longDisclaimer"],
                                key: "DisclaimerEdit_R1C2"
                            }
                        ],
                        key: "DisclaimerEdit_Row1"
                    }
                ]}
                mandatoryFieldNote="* = mandatory"
                idField="did"
                editableKeys={item => {
                    const { usedChannelGroups, channelGroupsList } = this.state;
                    return {
                        name: {
                            label: "Name",
                            required: true,
                            type: "text",
                            value: item.name,
                            placeholder: "Please Enter a Name",
                            mutateChange: async (key, value) => {
                                this._setState({ name: value });
                                return { name: value as string };
                            }
                        },
                        cid: {
                            label: "Client",
                            required: true,
                            type: "select",
                            hidden: !user.isSuper,
                            placeholder: "Please Select a Client",
                            value: item.cid || [],
                            values: (ssgClients || []).map(client => ({ label: client?.name, value: client?.cid })),
                            mutateChange: async (key, value) => {
                                const channelGroupsList = await doGetChannelGroups(value as string);
                                await this._getUsedChannels(value as string);
                                this.setState({ ...this.state, cid: value as string, channelGroupsList });
                                return { cid: value as string, clientMemberCount: null };
                            }
                        },
                        channelGroups: {
                            label: "Channel Groups",
                            required: true,
                            type: "multi-select",
                            value: item.channelGroups,
                            placeholder: "Please Select Channel Group(s)",
                            disabled: user.isSuper && !item.cid,
                            values: [
                                {
                                    label: "All Channels",
                                    value: "All Channels",
                                    optionDisabled: usedChannelGroups.length > 0
                                },
                                ...(channelGroupsList || []).map(v => ({
                                    label: v,
                                    value: v,
                                    optionDisabled:
                                        usedChannelGroups.includes(v) || usedChannelGroups.includes("All Channels")
                                }))
                            ],
                            mutateChange: async (key, value) => {
                                if (Array.isArray(value)) {
                                    const newUsedGroupState = usedChannelGroups.filter(
                                        usedGroups => !value.find(group => group === usedGroups)
                                    );
                                    if (value[value.length - 1] == "All Channels") {
                                        this._setState({ channelGroups: value, usedChannelGroups: newUsedGroupState });
                                        return { channelGroups: ["All Channels"] };
                                    } else {
                                        this._setState({
                                            channelGroups: value.filter(item => item != "All Channels"),
                                            usedChannelGroups: newUsedGroupState
                                        });
                                        return { channelGroups: value.filter(item => item != "All Channels") };
                                    }
                                }
                                this._setState({ channelGroups: value });
                                return { channelGroups: [value] } as Partial<Mongo.IDisclaimer>;
                            }
                        },
                        shortDisclaimer: {
                            label: "Disclaimer - Short",
                            required: true,
                            description:
                                "This disclaimer will be added to a user’s Twitter bio. If no long disclaimer is provided, this disclaimer will also be added to the user’s LinkedIn Profile summary and Facebook page impressum. Maximum 115 characters.",
                            value: item.shortDisclaimer,
                            type: "textarea",
                            max: 115,
                            mutateChange: async (key: string, value: string | boolean | string[] | Date) => {
                                this._setState({ shortDisclaimer: value });
                                return { shortDisclaimer: value } as Partial<Mongo.IDisclaimer>;
                            }
                        },
                        longDisclaimer: {
                            label: "Disclaimer - Long",
                            value: item.longDisclaimer,
                            type: "textarea",
                            description:
                                "If provided, this disclaimer will be added to the user’s LinkedIn Profile summary and Facebook page impressum. Maximum 1900 characters.",
                            max: 1900,
                            mutateChange: async (key: string, value: string | boolean | string[] | Date) => {
                                this._setState({ longDisclaimer: value });
                                return { longDisclaimer: value } as Partial<Mongo.IDisclaimer>;
                            }
                        }
                    };
                }}
            />
        );
    }
}
const mapStateToProps = state => ({
    user: state.session.admin
});
export default connect(mapStateToProps)(EditDisclaimer);
